import { FeatureFlag } from '@nirvana/shared/constants';

export enum Bundle {
  UNDEFINED = -1,
  PRODUCT_MSP_BUNDLE_A_LA_CARTE = 1,
  PRODUCT_MSP_BUNDLE_SECURE = 2,
  PRODUCT_MSP_BUNDLE_SECURE_PLUS = 3,
  PRODUCT_MSP_BUNDLE_SECURE_EXTRA = 4,
}

export interface AvailableBundles extends Map<[key: Bundle], BundleItem> {}

export interface BundleItem {
  addons: FeatureFlag[];
  delegateAddons: FeatureFlag[];
  delegateFeature: FeatureFlag;
  level: number;
  parentBundle: number | null;
  usableFeature: FeatureFlag;
  incompatibleAddons: FeatureFlag[];
}

export interface AvailableBundlesForAffectedDescendants extends Map<[key: Bundle], FeatureFlag> {}
